module.exports = __webpack_public_path__ + "img/james-hs.a0e0dd51.jpg";